<template>


</template>

<script>

export default {
name: "DoctorComponent",

}
</script>

<style scoped>

</style>